import { Input, InputGroup, InputLeftAddon, Stack } from "@chakra-ui/react";
import React from "react";
import { InputRowGrid } from "../../shared/InputRowGrid";
import { BsCurrencyDollar } from "react-icons/bs";

export default function JobBudget() {
  return (
    <Stack>
      <InputRowGrid
        heading="Project Budget"
        text="Define payment before work begins and pay only when work is delivered. "
        input={
          <InputGroup w="200px" mt={2}>
            <InputLeftAddon color="brand.500" bg="white">
              <BsCurrencyDollar />
            </InputLeftAddon>{" "}
            <Input type="number" defaultValue={0} />
          </InputGroup>
        }
      />
    </Stack>
  );
}
